import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductAIResponse } from '../models/ProductSuggestListModel'

export class GetProductAISuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/productSuggestAIList',
      requesterInfo,
    })
  }

  public async getProductAISuggest(): Promise<IProductAIResponse[]> {
    return await this.getAsync<IProductAIResponse[]>()
  }
}
